"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelationshipType = exports.EntitySide = void 0;
var EntitySide;
(function (EntitySide) {
    EntitySide["Top"] = "top";
    EntitySide["Bottom"] = "bottom";
    EntitySide["Left"] = "left";
    EntitySide["Right"] = "right";
    EntitySide["Unknown"] = "unknown";
})(EntitySide = exports.EntitySide || (exports.EntitySide = {}));
var RelationshipType;
(function (RelationshipType) {
    RelationshipType["OneToOne"] = "one-to-one";
    RelationshipType["OneToMany"] = "one-to-many";
    RelationshipType["ManyToOne"] = "many-to-one";
    RelationshipType["ManyToMany"] = "many-to-many";
})(RelationshipType = exports.RelationshipType || (exports.RelationshipType = {}));
//# sourceMappingURL=relationship-schema.js.map